import { Alert } from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useTranslation } from "react-i18next";

const NoShowChargeAlert = () => {
    const { t } = useTranslation();
    const { data: webBooking } = useWebBooking();

    const payedAmount = webBooking?.paymentEvents.at(-1)?.payedAmount;

    return (
        <Alert type="info" iconVerticalAlign="flex-start">
            {t("payment.noShowCharged", {
                amount: t("currency.onlyAmount", {
                    value: payedAmount,
                }),
            })}
        </Alert>
    );
};

export default NoShowChargeAlert;
